module.exports = __webpack_public_path__ + "media/images/status-future-issue-cc0c463f.svg";